import React, { Component } from 'react';
import { Col, Row, Button } from 'react-bootstrap';
import '../../css/phone/phone.css';
import { withTranslation } from "react-i18next";
import { connect } from 'react-redux';
import { compose } from 'redux';
import { duotone, solid } from '@fortawesome/fontawesome-svg-core/import.macro'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import WebRTC from '../../webrtc/webrtc';
import Toastr from '../utils/toastr';

class Display extends Component {

    constructor() {

        super();
        this.state = { time: "00:00:00", then: new Date(), showContactModal: false };
        this.timer = 0;
        this.count = this.count.bind(this);
        this.copy = this.copy.bind(this);

        this.sourceRef = React.createRef();
        this.remoteRef = React.createRef();
        this.toastrRef = React.createRef();
    }

    componentDidMount() {
        this.count();
        this.setState({
            then: this.props.phoneStatus.then || new Date()
        })
        this.timer = setInterval(this.count, 1000);

        WebRTC.setRemote(this.remoteRef.current);
        WebRTC.setSource(this.sourceRef.current);

    }

    count() {
        let then = new Date(this.state.then),
            phoneDiff = (new Date() - then) / 1000,
            seconds = Math.round(phoneDiff),
            result = new Date(seconds * 1000).toISOString().slice(11, 19);

        this.setState({
            time: result,
        });

        if (seconds === 0) {
            clearInterval(this.timer);
        }
    }

    async copy() {
        try {
            await navigator.clipboard.writeText(this.props.phoneStatus.party.length > this.props.party.length ? this.props.phoneStatus.party : this.props.party);
            console.log('Text copied to clipboard!');
            this.toastrRef.current.setType("info");
            this.toastrRef.current.setMessage(this.props.t("textcopied"));
            this.toastrRef.current.show();
        } catch (err) {
            console.error('Failed to copy text: ', err);
            alert("Failed to copy text. Please ensure the page is focused and permissions are granted.");
        }
    }

    render() {
        return (
            <>
                <Row>
                    {
                        (!this.props.showPhone) &&
                        <Col xxl={4}>
                            <div style={{ marginTop: "5px" }}><FontAwesomeIcon size='5x' icon={solid('circle-user')} /></div>
                        </Col>
                    }
                    <Col xxl={!this.props.showPhone ? 8 : ""}>
                        <Row>
                            <Col>
                                {
                                    (this.props.phoneStatus.inbound) &&
                                    <div style={{ marginBottom: "5px" }}><FontAwesomeIcon icon={duotone('arrow-down-left')} /><span> {this.state.time}</span></div>
                                }
                                {
                                    (!this.props.phoneStatus.inbound) &&
                                    <div style={{ marginBottom: "5px" }}><FontAwesomeIcon icon={duotone('arrow-up-right')} /><span> {this.state.time}</span></div>
                                }
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                {/* //! TODO: FIX THIS */}
                                <div className='fs-7'>{this.props.groupName}</div>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <span className="fs-7">
                                    {
                                        (this.props.partyName) &&
                                        this.props.partyName
                                    }
                                    {
                                        (!this.props.partyName) &&
                                        this.props.t("unknown")
                                    }
                                </span>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <span className="fs-7">{this.props.phoneStatus.party.length > this.props.party.length ? this.props.phoneStatus.party : this.props.party} <Button size='sm' onClick={this.copy}><FontAwesomeIcon icon={duotone('copy')} /></Button></span>
                            </Col>
                        </Row>

                        {
                            this.props.extraCallDataType === 'callinfo' &&
                            <Row>
                                <Col>
                                    <span className="fs-7">{this.props.extraCallData}</span>
                                </Col>
                            </Row>


                        }

                        {
                            this.props.extraCallDataType === 'link' &&
                            <Row>
                                <Col>
                                    <a href={this.props.extraCallData} style={{ color: "white" }} target="_blank" rel="noopener noreferrer">{this.props.extraCallData}</a>
                                </Col>
                            </Row>
                        }

                    </Col>
                </Row>
                {
                    (this.props.showPhone && !this.props.phoneStatus.isWebRTC) &&
                    <Row>
                        <Col>
                            <div style={{ marginTop: "5px" }}><FontAwesomeIcon size='5x' icon={solid('circle-user')} /></div>
                        </Col>
                    </Row>
                }

                <Row style={{ display: (this.props.showPhone && this.props.phoneStatus.isWebRTC ? "inline-block" : "none") }}>
                    <Col>
                        <div className='videocontainer'>
                            <div className='sourcecontainer'>
                                <video ref={this.sourceRef} id="sourcevideo" autoPlay muted></video>
                            </div>
                            <video ref={this.remoteRef} id="remotevideo" autoPlay>
                                <source src="" />
                            </video>
                        </div>
                    </Col>
                </Row>
                <Toastr ref={this.toastrRef} />
            </>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        groupName: state.agent.groupName,
        party: state.agent.party,
        partyName: state.agent.partyName,
        extraCallData: state.agent.extraCallData,
        extraCallDataType: state.agent.extraCallDataType

    };
};

export default compose(connect(mapStateToProps, {}), withTranslation())(Display);